import type { Translate } from '@/i18n'

// Mirrors the backend rule (core/user.go minimumLoginRunes): a new or changed
// login has at least 6 characters; a saved shorter one may stay as it is.
export function loginProblem(login: string, t: Translate, saved = ''): string | undefined {
  const value = login.trim()
  if (!value || value === saved) return undefined
  return [...value].length < 6 ? t('validation.loginLength') : undefined
}
